import { useEffect, useState } from 'react';

export function useActiveSection(
  ids: string[],
  rootMargin = '-20% 0px -70% 0px',
): string {
  const [active, setActive] = useState(ids[0] ?? '');
  const idsKey = ids.join('\u0001');

  // biome-ignore lint/correctness/useExhaustiveDependencies: idsKey captures id list; avoids unstable array reference noise
  useEffect(() => {
    if (!ids.length) return;

    const observers: IntersectionObserver[] = [];

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActive(id);
        },
        { rootMargin },
      );
      obs.observe(el);
      observers.push(obs);
    });

    return () => {
      for (const obs of observers) {
        obs.disconnect();
      }
    };
  }, [idsKey, rootMargin]);

  return active;
}
